
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    ACCOUNT INACTIVE
  </div>
</kendo-dialog-titlebar>

<div class="container">
  <div>
    <span><strong>This account is currently inactive.</strong></span><br><br>
    <span> <strong><button type="button" class="btn btn-link casi-button-link" (click)="linkClose()">Contact Us</button>
        for additional information.</strong></span>
  </div>
</div>

<kendo-dialog-actions>
  <button kendoButton themeColor="info" (click)="okClose()">
    OK</button>
</kendo-dialog-actions>
